import { CircularProgress, IconButton } from '@mui/material'
import { Delete, Edit } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import Box from '@mui/material/Box'

import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import { CustomerContactType, CustomerType } from 'shared/store/useCustomers/types'
import CustomTable from 'shared/components/CustomTable'

import { ContactModalType } from '../../types'
import Modal from './components/Modal'

interface Props {
   customerDetails?: CustomerType
}

export default function Contacts({ customerDetails }: Props) {
   const { t } = useTranslation('CUSTOMERS')
   const [modalDetails, setModalDetails] = useState<ContactModalType>({
      variant: undefined,
      open: false,
      contactDetails: undefined,
   })

   return (
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: '24px', justifyContent: 'center' }}>
         {customerDetails ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '16px' }}>
               <CustomTable
                  dependencies={[]}
                  disablePagination
                  dataSize={customerDetails.contacts.length}
                  rows={customerDetails.contacts}
                  columns={[
                     {
                        name: 'nameUser',
                        mainOnMobile: true,
                        renderCell: (row: CustomerContactType) => row.name,
                     },
                     {
                        name: 'surname',
                        mainOnMobile: true,
                        renderCell: (row: CustomerContactType) => row.surname,
                     },
                     {
                        name: 'email',
                        renderCell: (row: CustomerContactType) => row.email,
                     },
                     {
                        name: 'phoneNumber',
                        renderCell: (row: CustomerContactType) => row.phoneNumber,
                     },
                     {
                        name: 'description',
                        renderCell: (row: CustomerContactType) => row.comment,
                     },
                     {
                        name: '',
                        mainOnMobile: true,
                        renderCell: (row) => (
                           <Box sx={{ display: 'flex', gap: '4px' }}>
                              <IconButton
                                 onClick={() => setModalDetails({ open: true, variant: 'EDIT', contactDetails: row })}
                              >
                                 <Edit />
                              </IconButton>
                              <IconButton
                                 onClick={() => setModalDetails({ open: true, variant: 'DELETE', contactDetails: row })}
                                 sx={{ '&:hover': { color: 'red' } }}
                              >
                                 <Delete />
                              </IconButton>
                           </Box>
                        ),
                     },
                  ]}
               />
               <OutlinedButton
                  onClick={() => setModalDetails({ open: true, variant: 'CREATE', contactDetails: undefined })}
                  sx={{ m: '0 auto' }}
                  variant="outlined"
               >
                  {t('addContact')}
               </OutlinedButton>
            </Box>
         ) : (
            <CircularProgress />
         )}
         <Modal
            customerUuid={customerDetails?.uuid ?? ''}
            modalDetails={modalDetails}
            onClose={() => setModalDetails({ open: false, contactDetails: undefined, variant: undefined })}
         />
      </Box>
   )
}
